import React from 'react';

import { Stepper, StepperProps } from '@qbe/ads-core';

interface StepProgressProps extends Omit<StepperProps, 'children' | 'nonLinear'> {
  /** Array of strings to represent step labels */
  steps: { label: string; id: string }[];
  isFinHardship: boolean;
}

/**
 * @visibleName Step Progress
 */
const StepProgress = ({ activeStep = 0, steps, isFinHardship }: StepProgressProps) => {
  if (activeStep <= 0) return <div />;

  return (
    <Stepper
      nonLinear={false}
      activeStep={activeStep}
      completedSteps={[...Array(activeStep).keys()]}
      steps={steps}
      variant="ondark"
    />
  );
};

export default StepProgress;
